import { MOUTH_SHAPES } from '../constants/effects';

// From each mouth shape, which shapes can come next (and how likely), like syllables in speech.
const MOUTH_TRANSITIONS = {
  [MOUTH_SHAPES.CLOSED]: [
    [MOUTH_SHAPES.OVAL, 0.6],
    [MOUTH_SHAPES.TEETH, 0.4],
  ],
  [MOUTH_SHAPES.OVAL]: [
    [MOUTH_SHAPES.TEETH, 0.45],
    [MOUTH_SHAPES.CLOSED, 0.35],
    [MOUTH_SHAPES.OVAL, 0.2],
  ],
  [MOUTH_SHAPES.TEETH]: [
    [MOUTH_SHAPES.OVAL, 0.5],
    [MOUTH_SHAPES.CLOSED, 0.5],
  ],
};

// How long each shape is held while talking, in ms: [shortest, longest].
const MOUTH_HOLD_RANGES = {
  [MOUTH_SHAPES.CLOSED]: [70, 140],
  [MOUTH_SHAPES.OVAL]: [110, 220],
  [MOUTH_SHAPES.TEETH]: [90, 180],
};

/**
 * Picks the next mouth shape while talking. randomValue is in [0, 1).
 */
export function pickNextMouthShape(currentShape, randomValue = Math.random()) {
  const transitions = MOUTH_TRANSITIONS[currentShape] ?? MOUTH_TRANSITIONS[MOUTH_SHAPES.CLOSED];
  let cumulativeChance = 0;
  for (const [shape, chance] of transitions) {
    cumulativeChance += chance;
    if (randomValue < cumulativeChance) return shape;
  }
  return transitions[transitions.length - 1][0];
}

export function pickMouthHoldMs(shape, randomValue = Math.random()) {
  const [shortest, longest] = MOUTH_HOLD_RANGES[shape];
  return shortest + (longest - shortest) * randomValue;
}
